import React from 'react';

import P from 'prop-types';

import './styles.css';

export const CheckBox = ({ text = '', checked = false, val = '', name = 'checkPadrao' }) => {
  let check = checked ? 'checked' : '';

  return (
    <>
      <div className={'checkboxes float-left'}>
        <label className={'container-check'}>
          {text}
          <input type={'checkbox'} defaultChecked={check} value={val} name={name} />
          <span className={'checkmark'}></span>
        </label>
      </div>
    </>
  );
};

CheckBox.propTypes = {
  checked: P.boolean,
  text: P.string,
  val: P.string,
  name: P.string,
};
